module.exports = "/1/2-lenh-khoi-lenh-tu-khoa/index.html.64fc5d3945efcd20acd8f935da7161fd.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/29575.md
 ** module id = 531
 ** module chunks = 0
 **/